module.exports = __webpack_public_path__ + "img/9788959528110.f9a298c0.jpg";